<template>
  <div id="jupitersmoons" class="work-page" :class="{ 'detail-loaded' : isDetailVisible, 'work-page-loaded': isPageLoaded, 'work-library-modal': showModal }" @click="closeWorkShare">

    <div class="work__bg-wrap">
      <div class="work__bg">
        <img src="/assets/img/layout/bg-overview.jpg" class="work__bg-img"  alt="work background image">
      </div>
    </div>
    <div class="detail__bg" style="background-image: url('/assets/img/jupiters-moons/bg-info.jpg')"></div>
    <div class="container" >
      <div class="page__top">
        <h1 class="page-top__title">{{ $t('Jupitermonde') }}</h1>
        <p class="page-top__text">Sidereus Nuncius<br />(Galilei, 1610)</p>
      </div>
      <main class="main main--jmoons">
        <div class="work-content work-content--jmoons work-intro-ani-in">
          <div class="jmoons-work-container" :style="'margin-top:'+ workPosLive +'px'">
            <div class="work-scaleable scale-item">
              <div class="jmoons__slider-container ">
                <div class="jmoons__slider">
                  <div class="jmoons__nav">
                    <a :class="{ 'inactive' : activeSlide === jmoonsSlides.length - 1 }" class="next jmoons-nav__btn"  @click="clickStepUp" href="#"><span class="visuallyhidden">Next</span></a>
                    <a :class="{ 'inactive' : activeSlide === 0 }" class="prev jmoons-nav__btn"  @click="clickStepDown" href="#"><span class="visuallyhidden">Prev</span></a>
                    <span v-for="(slide, index) in jmoonsSlides" v-if="index == activeSlide" :key="'legend_'+index"  class="jmoons-nav__legend">{{ slide.legendDate }} {{ $t(slide.legendMonth) }} {{ slide.legendYearTime }}</span>
                  </div>
                  <template v-for="(slide, index) in jmoonsSlides">
                    <div v-show="index == activeSlide" :key="index" class="jmoons__slide-img-wrap">
                      <svg preserveAspectRatio="xMaxYMin meet" viewBox="0 0 335 51" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                          <path :id="'mask-path_'+index" :d="slide.svgpath"></path>
                        </defs>
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g>
                            <mask :id="'mask_'+index" fill="white">
                              <use :xlink:href="'#mask-path_'+index"></use>
                            </mask>
                            <use id="Mask" fill="#BDBDBD" :xlink:href="'#mask-path_'+index"></use>
                            <image :mask="'url(#mask_'+index+')'" width="335" height="51" :xlink:href="'/assets/img/jupiters-moons/'+slide.img"></image>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </template>
                </div>
              </div>
              <div class="jmoons__moons-container ">
                <div class="jmoons__moons-inner-container">
                  <div class="jmoon-0 jmoon"></div>
                  <div class="jmoon-1 jmoon"></div>
                  <div class="jmoon-2 jmoon"></div>
                  <div class="jmoon-3 jmoon"></div>
                  <div class="jmoon-jupiter"><img src="/assets/img/jupiters-moons/jupiter-icon-nav.png" alt="jupiter icon"> </div>
                </div>
              </div>
            </div>
            <div class="jmoons-curves-container">
              <div class="jmoons-curves-touch-area"></div>
              <div class="jmoons-curves-interctiv-container">

                <div class="jmoons-curves__mask-container">

                  <svg class="jmoons-curves__mask" preserveAspectRatio="xMaxYMin meet" viewBox="0 0 335 677" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <defs>
                      <path d="M167.2,677.2 L167.2,0" id="path-1"></path>
                      <filter x="-450.0%" y="-1.2%" width="1000.0%" height="103.0%" filterUnits="objectBoundingBox" id="filter-2">
                        <feMorphology radius="2" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"></feMorphology>
                        <feOffset dx="0" dy="2" in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
                        <feMorphology radius="2" operator="erode" in="SourceAlpha" result="shadowInner"></feMorphology>
                        <feOffset dx="0" dy="2" in="shadowInner" result="shadowInner"></feOffset>
                        <feComposite in="shadowOffsetOuter1" in2="shadowInner" operator="out" result="shadowOffsetOuter1"></feComposite>
                        <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                      </filter>
                      <filter x="-16.7%" y="-1.7%" width="133.3%" height="103.4%" filterUnits="objectBoundingBox" id="filter-3">
                        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                        <feMerge>
                          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                          <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                      </filter>
                      <filter x="-10.4%" y="-1.7%" width="119.8%" height="103.4%" filterUnits="objectBoundingBox" id="filter-4">
                        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                        <feMerge>
                          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                          <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                      </filter>
                      <filter x="-6.6%" y="-1.7%" width="112.6%" height="103.4%" filterUnits="objectBoundingBox" id="filter-5">
                        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                        <feMerge>
                          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                          <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                      </filter>
                      <filter x="-3.5%" y="-1.7%" width="107.0%" height="103.3%" filterUnits="objectBoundingBox" id="filter-6">
                        <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur stdDeviation="2.5" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                        <feMerge>
                          <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                          <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                      </filter>
                    </defs>
                    <g id="curves_deco" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="JovMoons_araII_cleaned_2">
                        <rect id="bg" fill-opacity="0" fill="#9F9F9F" fill-rule="nonzero" x="0" y="0" width="334.8" height="677"></rect>
                        <g id="j">
                          <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                          <use stroke="#FFFFFF" stroke-width="2" xlink:href="#path-1"></use>
                        </g>
                        <g id="_x30_1-2" filter="url(#filter-3)" transform="translate(133.000000, 0.000000)" stroke="#759BDE" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <polyline id="_x30_1" points="33.4 0 19 3 10.8 5 4.6 7 2.6 8 1.2 9 0.2 10 0.2 11 0.8 12 2.2 13 4.4 14 10.4 16 18.6 18 38 22 52 25 59.6 27 65 29 66.8 30 67.8 31 68.2 32 67.8 33 66.6 34 64.8 35 62.4 36 55.6 38 47 40 10.2 48 4.2 50 2.2 51 0.8 52 0.2 53 0.2 54 1 55 2.6 56 4.8 57 11 59 19.2 61 38.8 65 52.8 68 60.2 70 65.4 72 67 73 68 74 68.2 75 67.6 76 66.4 77 64.4 78 58.6 80 50.8 82 36.6 85 17.4 89 9.6 91 3.8 93 1.8 94 0.6 95 -8.52651283e-14 96 0.2 97 1.2 98 2.8 99 5.2 100 11.6 102 20 104 57.4 112 63.6 114 65.8 115 67.4 116 68.2 117 68.2 118 67.6 119 66.2 120 64.2 121 58.2 123 50.2 125 36 128 17 132 9.2 134 3.6 136 1.8 137 0.6 137.8 0.2 138.8 0.4 139.8 1.4 140.8 3.2 141.8 5.6 142.8 12.2 144.8 20.6 146.8 57.8 154.8 63.8 156.8 66 157.8 67.4 158.8 68.2 159.8 68.2 160.8 67.4 161.8 66 162.8 63.8 163.8 57.6 165.8 49.6 167.8 30.2 171.8 16.2 174.8 8.6 176.8 3.2 178.8 1.4 179.8 0.4 180.8 -8.52651283e-14 181.8 0.4 182.8 1.6 183.8 3.4 184.8 5.8 185.8 12.6 187.8 21.2 189.8 54.4 196.8 61.4 198.8 64 199.8 66 200.8 67.4 201.8 68 202.8 67.8 203.8 67 204.8 65.4 205.8 63.2 206.8 57 208.8 48.8 210.8 29.4 214.8 15.6 217.8 8.2 219.8 3 221.8 1.4 222.8 0.4 223.8 0.2 224.8 0.8 225.8 2 226.8 4 227.8 9.8 229.8 17.8 231.8 32.2 234.8 51.4 238.8 59.2 240.8 65 242.8 67 243.8 68.2 244.8 68.6 245.8 68.4 246.8 67.4 247.8 65.8 248.8 63.4 249.8 57 251.8 48.6 253.8 11.4 261.8 5.2 263.8 3 264.8 1.4 265.8 0.6 266.8 0.4 267.8 1 268.8 2.4 269.8 4.4 270.8 10.4 272.8 18.4 274.8 32.8 277.8 52 281.8 59.8 283.8 65.4 285.8 67.2 286.8 68.4 287.8 68.8 288.8 68.4 289.8 67.4 290.8 65.6 291.8 63.2 292.8 56.6 294.8 48.2 296.8 11.2 304.8 5 306.8 2.8 307.8 1.4 308.8 0.6 309.8 0.6 310.8 1.4 311.8 2.8 312.8 5 313.8 11.2 315.8 19.4 317.8 38.8 321.8 52.8 324.8 60.4 326.8 65.8 328.8 67.6 329.8 68.6 330.8 68.8 331.8 68.4 332.8 67.2 333.8 65.4 334.8 59.8 336.8 52 338.8 38 341.8 18.8 345.8 10.8 347.8 4.8 349.8 2.8 350.8 1.4 351.8 0.8 352.8 1 353.8 1.8 354.8 3.4 355.8 5.6 356.8 12 358.8 20.2 360.8 39.8 364.8 53.8 367.8 61.2 369.8 66.4 371.8 68 372.8 68.8 373.8 69 374.8 68.4 375.8 67.2 376.8 65.2 377.8 59.4 379.8 51.6 381.8 37.4 384.8 18.2 388.8 10.4 390.8 4.6 392.8 2.6 393.8 1.4 394.8 0.8 395.8 1 396.8 2 397.8 3.6 398.8 6 399.8 12.4 401.8 20.8 403.8 58.2 411.8 64.4 413.8 66.6 414.8 68.2 415.8 69 416.8 69 417.8 68.4 418.8 67 419.8 65 420.8 59 422.8 51 424.8 36.8 427.8 17.8 431.8 10 433.8 4.4 435.8 2.6 436.8 1.4 437.8 1 438.8 1.4 439.8 2.4 440.8 4.2 441.8 6.6 442.8 13.2 444.8 21.8 446.8 59 454.8 65 456.8 67 457.8 68.4 458.8 69 459.8 69 460.8 68.2 461.8 66.8 462.8 64.6 463.8 58.4 465.8 50.2 467.8 30.8 471.8 16.8 474.8 9.2 476.8 3.8 478.8 2 479.8 1 480.8 0.6 481.8 0.6 482 1.8 483 3.6 484 6.2 485 13 487 21.6 489 54.8 496 61.8 498 64.4 499 66.4 500 67.8 501 68.4 502 68.2 503 67.4 504 65.8 505 63.6 506 57.4 508 49.2 510 29.8 514 15.8 517 8.4 519 3.2 521 1.6 522 0.6 523 0.4 524 1 525 2.2 526 4.2 527 10 529 18 531 32.4 534 51.6 538 59.4 540 65.2 542 67.2 543 68.4 544 68.8 545 68.6 546 67.6 547 66 548 63.6 549 57.2 551 48.8 553 11.6 561 5.4 563 3.2 564 1.6 565 0.8 566 0.6 567 1.2 568 2.6 569 4.6 570 10.6 572 18.6 574 33 577 52.2 581 60 583 65.6 585 67.4 586 68.6 587 69 588 68.6 589 67.6 590 65.8 591 63.4 592 56.8 594 48.4 596 11.4 604 5.2 606 3 607 1.6 608 0.8 609 0.8 610 1.6 611 3 612 5.2 613 11.4 615 19.6 617 39 621 53 624 60.6 626 66 628 67.8 629 68.8 630 69 631 68.6 632 67.4 633 65.6 634 60 636 52.2 638 38.2 641 19 645 11 647 5 649 3 650 1.6 651 1 652 1 653 1.8 654 3.4 655 5.6 656 11.8 658 20 660 39.6 664 53.6 667 61 669 66.2 671 67.8 672 68.8 673 69 674 68.4 675 67.2 676 65.2 677 65.2 677"></polyline>
                        </g>
                        <g id="_x30_2-2" filter="url(#filter-4)" transform="translate(112.000000, 0.000000)" stroke="#759BDE" stroke-dasharray="3,3" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M1.2,0 L1,1 L1,2 L1.4,3 L2,4 L4,6 L7.2,8 L11.4,10 L16.4,12 L25.4,15 L39.6,19 L84.8,31 L93.8,34 L98.8,36 L103,38 L106.2,40 L108.2,42 L108.8,43 L109.2,44 L109.2,45 L109,46 L108.4,47 L106.4,49 L103.4,51 L99.2,53 L94.2,55 L85,58 L70.6,62 L24.8,74 L15.6,76.8 L10.6,78.8 L6.6,80.8 L3.6,82.8 L1.6,84.8 L1,85.8 L0.8,86.8 L0.8,87.8 L1.2,88.8 L1.8,89.8 L3.8,91.8 L7,93.8 L11.2,95.8 L16.2,97.8 L25.2,100.8 L39.4,104.8 L84.6,116.8 L93.8,119.8 L98.8,121.8 L103,123.8 L106.2,125.8 L108.2,127.8 L108.8,128.8 L109.2,129.8 L109.2,130.8 L109,131.8 L108.4,132.8 L106.4,134.8 L103.4,136.8 L99.2,138.8 L94.2,140.8 L85,143.8 L70.6,147.8 L24.8,159.8 L15.8,162.8 L10.8,164.8 L6.8,166.8 L3.8,168.8 L1.8,170.8 L1.2,171.8 L1,172.8 L1,173.8 L1.4,174.8 L2,175.8 L4,177.8 L7.2,179.8 L11.4,181.8 L16.4,183.8 L25.4,186.8 L39.6,190.8 L84.8,202.8 L94,205.8 L99,207.8 L103.2,209.8 L106.4,211.8 L108.4,213.8 L109,214.8 L109.4,215.8 L109.4,216.8 L109.2,217.8 L108.6,218.8 L106.6,220.8 L103.6,222.8 L99.4,224.8 L94.4,226.8 L85.2,229.8 L70.8,233.8 L25,245.8 L16,248.8 L11,250.8 L7,252.8 L4,254.8 L2,256.8 L1.4,257.8 L1.2,258.8 L1.2,259.8 L1.6,260.8 L2.2,261.8 L4.2,263.8 L7.4,265.8 L11.6,267.8 L16.6,269.8 L25.6,272.8 L39.8,276.8 L85,288.8 L94.2,291.8 L99.4,293.8 L103.6,295.8 L106.8,297.8 L108.8,299.8 L109.4,300.8 L109.8,301.8 L109.8,302.8 L109.6,303.8 L109,304.8 L107,306.8 L104,308.8 L99.8,310.8 L94.8,312.8 L85.6,315.8 L71.2,319.8 L25.4,331.8 L16.4,334.8 L11.4,336.8 L7.4,338.8 L4.4,340.8 L2.4,342.8 L1.8,343.8 L1.6,344.8 L1.6,345.8 L2,346.8 L2.6,347.8 L4.6,349.8 L7.8,351.8 L12,353.8 L17,355.8 L26,358.8 L40.2,362.8 L88.6,375.8 L97.2,378.8 L101.8,380.8 L105.6,382.8 L108.2,384.8 L109.8,386.8 L110.2,387.8 L110.2,388.8 L110,389.8 L109.4,390.8 L107.4,392.8 L104.4,394.8 L100.4,396.8 L95.4,398.8 L86.2,401.8 L75.6,404.8 L52,410.8 L32.8,415.8 L21.6,418 L13,421 L8.4,423 L4.8,425 L2.2,427 L0.8,429 L0.6,430 L0.6,431 L0.8,432 L1.4,433 L3.4,435 L6.4,437 L10.4,439 L15.4,441 L24.4,444 L38.6,448 L87.2,461 L95.8,464 L100.4,466 L104.2,468 L106.8,470 L108.4,472 L108.8,473 L108.8,474 L108.6,475 L108,476 L106,478 L103,480 L99,482 L94,484 L84.8,487 L74.2,490 L50.6,496 L31.4,501 L21.2,504 L12.6,507 L8,509 L4.4,511 L1.8,513 L0.4,515 L0.2,516 L0.2,517 L0.4,518 L1,519 L3,521 L6,523 L10,525 L15,527 L24,530 L34.4,533 L53.6,538 L76.6,544 L86.8,547 L95.4,550 L100.2,552 L104,554 L106.8,556 L108.4,558 L108.8,559 L108.8,560 L108.6,561 L108,562 L107.2,563 L104.8,565 L101.2,567 L96.6,569 L91.2,571 L81.6,574 L66.8,578 L28.2,588 L18.4,591 L10.4,594 L6.2,596 L3,598 L1,600 L0.4,601 L-1.44950718e-12,602 L-1.44950718e-12,603 L0.2,604 L0.8,605 L2.8,607 L5.8,609 L9.8,611 L14.8,613 L23.8,616 L34.2,619 L53.4,624 L76.4,630 L86.6,633 L95.4,636 L100.2,638 L104,640 L106.8,642 L108.4,644 L108.8,645 L108.8,646 L108.6,647 L108.2,648 L107.4,649 L105,651 L101.6,653 L97,655 L91.6,657 L82,660 L67.2,664 L28.6,674 L18.8,677 L18.8,677" id="_x30_2"></path>
                        </g>
                        <g id="_x30_3-2" filter="url(#filter-5)" transform="translate(80.600000, 0.000000)" stroke="#759BDE" stroke-dasharray="5,5" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M36.6,0 L27,4 L18.6,8 L13.2,11 L8.6,14 L5,17 L3.2,19 L1.8,21 L0.8,23 L0.2,25 L0.2,27 L0.6,29 L1.4,31 L2.6,33 L4.2,35 L6.4,37 L10.4,40 L15.2,43 L21,46 L29.8,50 L39.8,54 L53.6,59 L71.6,65 L123.6,82 L137,87 L146.6,91 L155,95 L160.4,98 L164.8,101 L168.4,104 L170.2,106 L171.6,108 L172.6,110 L173,112 L173,114 L172.6,116 L171.6,118 L170.2,120 L168.4,122 L165,125 L160.6,128 L155.4,131 L149.2,134 L140,138 L129.6,142 L115.4,147 L94,154 L57,166 L42.8,171 L32.4,175 L23.2,179 L17.2,182 L12,185 L7.6,188 L4.2,191 L2.4,193 L1.2,195 L0.4,197 L2.17426077e-12,199 L2.17426077e-12,201 L0.6,203 L1.6,205 L3,207 L4.8,209 L8.4,212 L12.8,215 L18.2,218 L24.4,221 L33.8,225 L44.2,229 L58.4,234 L83,242 L116.8,253 L131,258 L141.2,262 L150.2,266 L156.2,269 L161.4,272 L165.6,275 L168.8,278 L170.4,280 L171.6,282 L172.4,284 L172.8,286 L172.6,288 L172,290 L171,292 L169.6,294 L167.6,296 L164,299 L159.4,302 L154,305 L147.8,308 L138.4,312 L127.8,316 L113.4,321 L88.8,329 L58,339 L43.8,344 L31,349 L22,353 L16.2,356 L11.2,359 L7,362 L3.8,365 L2.2,367 L1,369 L0.4,371 L0.2,373 L0.4,375 L1,377 L2.2,379 L3.8,381 L5.8,383 L9.6,386 L14.2,389 L19.8,392 L28.4,396 L38.2,400 L51.8,405 L69.6,411 L124.6,429 L138,434 L147.6,438 L155.8,442 L161,445 L165.4,448 L168.8,451 L170.6,453 L172,455 L172.8,457 L173.2,459 L173.2,461 L172.6,463 L171.6,465 L170.2,467 L168.4,469 L164.8,472 L160.4,475 L155,478 L148.8,481 L139.4,485 L129,489 L114.8,494 L90.2,502 L56.4,513 L42.4,518 L32.2,522 L23,526 L17,529 L11.8,532 L7.6,535 L4.2,538 L2.6,540 L1.4,542 L0.6,544 L0.2,546 L0.4,548 L1,550 L2,552 L3.4,554 L5.2,556 L8.8,559 L13.4,562 L18.8,565 L25,568 L34.4,572 L44.8,576 L59.2,581 L83.8,589 L117.6,600 L131.6,605 L141.8,609 L150.8,613 L156.8,616 L161.8,619 L166,622 L169.2,625 L170.8,627 L172,629 L172.8,631 L173,633 L172.8,635 L172.2,637 L171.2,639 L169.6,641 L167.6,643 L163.8,646 L159.2,649 L153.6,652 L147.4,655 L138,659 L124.6,664 L107,670 L82.2,678 L82.2,678" id="_x30_3"></path>
                        </g>
                        <g id="_x30_4-2" filter="url(#filter-6)" transform="translate(15.400000, 0.000000)" stroke="#759BDE" stroke-dasharray="7,7" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5">
                          <path d="M268,5.68434189e-14 L275.2,5 L281.8,10 L287.6,15 L291.6,19 L295,23 L298,27 L300.4,31 L302.2,35 L303.4,39 L304,43 L304,47 L303.4,51 L302.2,55 L300.6,59 L298.4,63 L295.6,67 L292.2,71 L288.2,75 L283.8,79 L277.4,84 L270.4,89 L262.6,94 L252.4,100 L241.2,106 L227.2,113 L210.2,121 L190,130 L159.4,143 L110,164 L89.8,173 L73,181 L59.2,188 L48.4,194 L38.4,200 L30.8,205 L24,210 L18,215 L13.8,219 L10.2,223 L7,227 L4.4,231 L2.4,235 L1,239 L0.2,243 L2.84217094e-14,247 L0.4,251 L1.4,255 L3,259 L5,263 L7.6,267 L10.8,271 L14.6,275 L18.8,279 L24.8,284 L31.6,289 L39.2,294 L49.2,300 L60,306 L73.6,313 L90.2,321 L110,330 L137.6,342 L197.8,368 L217.4,377 L233.8,385 L247.2,392 L257.8,398 L267.4,404 L274.8,409 L281.4,414 L287.2,419 L291.2,423 L294.8,427 L297.8,431 L300.2,435 L302,439 L303.4,443 L304.2,447 L304.4,451 L304,455 L303,459 L301.4,463 L299.2,467 L296.4,471 L293.2,475 L289.4,479 L285,483 L278.8,488 L271.8,493 L264.2,498 L254,504 L243,510 L229.2,517 L212.2,525 L192,534 L164,546 L107.6,570 L87.6,579 L71,587 L57.4,594 L46.6,600 L36.8,606 L29.4,611 L22.8,616 L17,621 L13,625 L9.4,629 L6.4,633 L4,637 L2.2,641 L1,645 L0.2,649 L2.84217094e-14,653 L0.4,657 L1.4,661 L3,665 L5.2,669 L8,673 L11.4,677 L12.4,678 L22.8,690.367091 L328.98393,690.367091" id="_x30_4"></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="jmoons-curves__path-container">
                  <svg class="jmoons-curves__path" preserveAspectRatio="xMaxYMin meet" viewBox="0 0 335 677" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g id="curves_info" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="curves_pathes">
                        <rect id="bg" fill="" fill-rule="nonzero" x="0" y="0" width="334.8" height="677"></rect>
                        <line x1="167.2" y1="677.2" x2="167.2" y2="0" id="j" stroke="#000000" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"></line>
                        <polyline id="jmoon-path-0" class="jmoon-path" stroke-opacity="1" stroke="red" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" points="166.4 0 152 3 143.8 5 137.6 7 135.6 8 134.2 9 133.2 10 133.2 11 133.8 12 135.2 13 137.4 14 143.4 16 151.6 18 171 22 185 25 192.6 27 198 29 199.8 30 200.8 31 201.2 32 200.8 33 199.6 34 197.8 35 195.4 36 188.6 38 180 40 143.2 48 137.2 50 135.2 51 133.8 52 133.2 53 133.2 54 134 55 135.6 56 137.8 57 144 59 152.2 61 171.8 65 185.8 68 193.2 70 198.4 72 200 73 201 74 201.2 75 200.6 76 199.4 77 197.4 78 191.6 80 183.8 82 169.6 85 150.4 89 142.6 91 136.8 93 134.8 94 133.6 95 133 96 133.2 97 134.2 98 135.8 99 138.2 100 144.6 102 153 104 190.4 112 196.6 114 198.8 115 200.4 116 201.2 117 201.2 118 200.6 119 199.2 120 197.2 121 191.2 123 183.2 125 169 128 150 132 142.2 134 136.6 136 134.8 137 133.6 137.8 133.2 138.8 133.4 139.8 134.4 140.8 136.2 141.8 138.6 142.8 145.2 144.8 153.6 146.8 190.8 154.8 196.8 156.8 199 157.8 200.4 158.8 201.2 159.8 201.2 160.8 200.4 161.8 199 162.8 196.8 163.8 190.6 165.8 182.6 167.8 163.2 171.8 149.2 174.8 141.6 176.8 136.2 178.8 134.4 179.8 133.4 180.8 133 181.8 133.4 182.8 134.6 183.8 136.4 184.8 138.8 185.8 145.6 187.8 154.2 189.8 187.4 196.8 194.4 198.8 197 199.8 199 200.8 200.4 201.8 201 202.8 200.8 203.8 200 204.8 198.4 205.8 196.2 206.8 190 208.8 181.8 210.8 162.4 214.8 148.6 217.8 141.2 219.8 136 221.8 134.4 222.8 133.4 223.8 133.2 224.8 133.8 225.8 135 226.8 137 227.8 142.8 229.8 150.8 231.8 165.2 234.8 184.4 238.8 192.2 240.8 198 242.8 200 243.8 201.2 244.8 201.6 245.8 201.4 246.8 200.4 247.8 198.8 248.8 196.4 249.8 190 251.8 181.6 253.8 144.4 261.8 138.2 263.8 136 264.8 134.4 265.8 133.6 266.8 133.4 267.8 134 268.8 135.4 269.8 137.4 270.8 143.4 272.8 151.4 274.8 165.8 277.8 185 281.8 192.8 283.8 198.4 285.8 200.2 286.8 201.4 287.8 201.8 288.8 201.4 289.8 200.4 290.8 198.6 291.8 196.2 292.8 189.6 294.8 181.2 296.8 144.2 304.8 138 306.8 135.8 307.8 134.4 308.8 133.6 309.8 133.6 310.8 134.4 311.8 135.8 312.8 138 313.8 144.2 315.8 152.4 317.8 171.8 321.8 185.8 324.8 193.4 326.8 198.8 328.8 200.6 329.8 201.6 330.8 201.8 331.8 201.4 332.8 200.2 333.8 198.4 334.8 192.8 336.8 185 338.8 171 341.8 151.8 345.8 143.8 347.8 137.8 349.8 135.8 350.8 134.4 351.8 133.8 352.8 134 353.8 134.8 354.8 136.4 355.8 138.6 356.8 145 358.8 153.2 360.8 172.8 364.8 186.8 367.8 194.2 369.8 199.4 371.8 201 372.8 201.8 373.8 202 374.8 201.4 375.8 200.2 376.8 198.2 377.8 192.4 379.8 184.6 381.8 170.4 384.8 151.2 388.8 143.4 390.8 137.6 392.8 135.6 393.8 134.4 394.8 133.8 395.8 134 396.8 135 397.8 136.6 398.8 139 399.8 145.4 401.8 153.8 403.8 191.2 411.8 197.4 413.8 199.6 414.8 201.2 415.8 202 416.8 202 417.8 201.4 418.8 200 419.8 198 420.8 192 422.8 184 424.8 169.8 427.8 150.8 431.8 143 433.8 137.4 435.8 135.6 436.8 134.4 437.8 134 438.8 134.4 439.8 135.4 440.8 137.2 441.8 139.6 442.8 146.2 444.8 154.8 446.8 192 454.8 198 456.8 200 457.8 201.4 458.8 202 459.8 202 460.8 201.2 461.8 199.8 462.8 197.6 463.8 191.4 465.8 183.2 467.8 163.8 471.8 149.8 474.8 142.2 476.8 136.8 478.8 135 479.8 134 480.8 133.6 481.8 133.6 482 134.8 483 136.6 484 139.2 485 146 487 154.6 489 187.8 496 194.8 498 197.4 499 199.4 500 200.8 501 201.4 502 201.2 503 200.4 504 198.8 505 196.6 506 190.4 508 182.2 510 162.8 514 148.8 517 141.4 519 136.2 521 134.6 522 133.6 523 133.4 524 134 525 135.2 526 137.2 527 143 529 151 531 165.4 534 184.6 538 192.4 540 198.2 542 200.2 543 201.4 544 201.8 545 201.6 546 200.6 547 199 548 196.6 549 190.2 551 181.8 553 144.6 561 138.4 563 136.2 564 134.6 565 133.8 566 133.6 567 134.2 568 135.6 569 137.6 570 143.6 572 151.6 574 166 577 185.2 581 193 583 198.6 585 200.4 586 201.6 587 202 588 201.6 589 200.6 590 198.8 591 196.4 592 189.8 594 181.4 596 144.4 604 138.2 606 136 607 134.6 608 133.8 609 133.8 610 134.6 611 136 612 138.2 613 144.4 615 152.6 617 172 621 186 624 193.6 626 199 628 200.8 629 201.8 630 202 631 201.6 632 200.4 633 198.6 634 193 636 185.2 638 171.2 641 152 645 144 647 138 649 136 650 134.6 651 134 652 134 653 134.8 654 136.4 655 138.6 656 144.8 658 153 660 172.6 664 186.6 667 194 669 199.2 671 200.8 672 201.8 673 202 674 201.4 675 200.2 676 198.2 677 198.2 677"></polyline>
                        <polyline id="jmoon-path-1" class="jmoon-path" stroke-opacity="1" stroke="blue" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" points="113.2 0 113 1 113 2 113.4 3 114 4 116 6 119.2 8 123.4 10 128.4 12 137.4 15 151.6 19 196.8 31 205.8 34 210.8 36 215 38 218.2 40 220.2 42 220.8 43 221.2 44 221.2 45 221 46 220.4 47 218.4 49 215.4 51 211.2 53 206.2 55 197 58 182.6 62 136.8 74 127.6 76.8 122.6 78.8 118.6 80.8 115.6 82.8 113.6 84.8 113 85.8 112.8 86.8 112.8 87.8 113.2 88.8 113.8 89.8 115.8 91.8 119 93.8 123.2 95.8 128.2 97.8 137.2 100.8 151.4 104.8 196.6 116.8 205.8 119.8 210.8 121.8 215 123.8 218.2 125.8 220.2 127.8 220.8 128.8 221.2 129.8 221.2 130.8 221 131.8 220.4 132.8 218.4 134.8 215.4 136.8 211.2 138.8 206.2 140.8 197 143.8 182.6 147.8 136.8 159.8 127.8 162.8 122.8 164.8 118.8 166.8 115.8 168.8 113.8 170.8 113.2 171.8 113 172.8 113 173.8 113.4 174.8 114 175.8 116 177.8 119.2 179.8 123.4 181.8 128.4 183.8 137.4 186.8 151.6 190.8 196.8 202.8 206 205.8 211 207.8 215.2 209.8 218.4 211.8 220.4 213.8 221 214.8 221.4 215.8 221.4 216.8 221.2 217.8 220.6 218.8 218.6 220.8 215.6 222.8 211.4 224.8 206.4 226.8 197.2 229.8 182.8 233.8 137 245.8 128 248.8 123 250.8 119 252.8 116 254.8 114 256.8 113.4 257.8 113.2 258.8 113.2 259.8 113.6 260.8 114.2 261.8 116.2 263.8 119.4 265.8 123.6 267.8 128.6 269.8 137.6 272.8 151.8 276.8 197 288.8 206.2 291.8 211.4 293.8 215.6 295.8 218.8 297.8 220.8 299.8 221.4 300.8 221.8 301.8 221.8 302.8 221.6 303.8 221 304.8 219 306.8 216 308.8 211.8 310.8 206.8 312.8 197.6 315.8 183.2 319.8 137.4 331.8 128.4 334.8 123.4 336.8 119.4 338.8 116.4 340.8 114.4 342.8 113.8 343.8 113.6 344.8 113.6 345.8 114 346.8 114.6 347.8 116.6 349.8 119.8 351.8 124 353.8 129 355.8 138 358.8 152.2 362.8 200.6 375.8 209.2 378.8 213.8 380.8 217.6 382.8 220.2 384.8 221.8 386.8 222.2 387.8 222.2 388.8 222 389.8 221.4 390.8 219.4 392.8 216.4 394.8 212.4 396.8 207.4 398.8 198.2 401.8 187.6 404.8 164 410.8 144.8 415.8 133.6 418 125 421 120.4 423 116.8 425 114.2 427 112.8 429 112.6 430 112.6 431 112.8 432 113.4 433 115.4 435 118.4 437 122.4 439 127.4 441 136.4 444 150.6 448 199.2 461 207.8 464 212.4 466 216.2 468 218.8 470 220.4 472 220.8 473 220.8 474 220.6 475 220 476 218 478 215 480 211 482 206 484 196.8 487 186.2 490 162.6 496 143.4 501 133.2 504 124.6 507 120 509 116.4 511 113.8 513 112.4 515 112.2 516 112.2 517 112.4 518 113 519 115 521 118 523 122 525 127 527 136 530 146.4 533 165.6 538 188.6 544 198.8 547 207.4 550 212.2 552 216 554 218.8 556 220.4 558 220.8 559 220.8 560 220.6 561 220 562 219.2 563 216.8 565 213.2 567 208.6 569 203.2 571 193.6 574 178.8 578 140.2 588 130.4 591 122.4 594 118.2 596 115 598 113 600 112.4 601 112 602 112 603 112.2 604 112.8 605 114.8 607 117.8 609 121.8 611 126.8 613 135.8 616 146.2 619 165.4 624 188.4 630 198.6 633 207.4 636 212.2 638 216 640 218.8 642 220.4 644 220.8 645 220.8 646 220.6 647 220.2 648 219.4 649 217 651 213.6 653 209 655 203.6 657 194 660 179.2 664 140.6 674 130.8 677 130.8 677"></polyline>
                        <polyline id="jmoon-path-2" class="jmoon-path" stroke-opacity="1" stroke="green" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" points="117.2 0 107.6 4 99.2 8 93.8 11 89.2 14 85.6 17 83.8 19 82.4 21 81.4 23 80.8 25 80.8 27 81.2 29 82 31 83.2 33 84.8 35 87 37 91 40 95.8 43 101.6 46 110.4 50 120.4 54 134.2 59 152.2 65 204.2 82 217.6 87 227.2 91 235.6 95 241 98 245.4 101 249 104 250.8 106 252.2 108 253.2 110 253.6 112 253.6 114 253.2 116 252.2 118 250.8 120 249 122 245.6 125 241.2 128 236 131 229.8 134 220.6 138 210.2 142 196 147 174.6 154 137.6 166 123.4 171 113 175 103.8 179 97.8 182 92.6 185 88.2 188 84.8 191 83 193 81.8 195 81 197 80.6 199 80.6 201 81.2 203 82.2 205 83.6 207 85.4 209 89 212 93.4 215 98.8 218 105 221 114.4 225 124.8 229 139 234 163.6 242 197.4 253 211.6 258 221.8 262 230.8 266 236.8 269 242 272 246.2 275 249.4 278 251 280 252.2 282 253 284 253.4 286 253.2 288 252.6 290 251.6 292 250.2 294 248.2 296 244.6 299 240 302 234.6 305 228.4 308 219 312 208.4 316 194 321 169.4 329 138.6 339 124.4 344 111.6 349 102.6 353 96.8 356 91.8 359 87.6 362 84.4 365 82.8 367 81.6 369 81 371 80.8 373 81 375 81.6 377 82.8 379 84.4 381 86.4 383 90.2 386 94.8 389 100.4 392 109 396 118.8 400 132.4 405 150.2 411 205.2 429 218.6 434 228.2 438 236.4 442 241.6 445 246 448 249.4 451 251.2 453 252.6 455 253.4 457 253.8 459 253.8 461 253.2 463 252.2 465 250.8 467 249 469 245.4 472 241 475 235.6 478 229.4 481 220 485 209.6 489 195.4 494 170.8 502 137 513 123 518 112.8 522 103.6 526 97.6 529 92.4 532 88.2 535 84.8 538 83.2 540 82 542 81.2 544 80.8 546 81 548 81.6 550 82.6 552 84 554 85.8 556 89.4 559 94 562 99.4 565 105.6 568 115 572 125.4 576 139.8 581 164.4 589 198.2 600 212.2 605 222.4 609 231.4 613 237.4 616 242.4 619 246.6 622 249.8 625 251.4 627 252.6 629 253.4 631 253.6 633 253.4 635 252.8 637 251.8 639 250.2 641 248.2 643 244.4 646 239.8 649 234.2 652 228 655 218.6 659 205.2 664 187.6 670 162.8 678 162.8 678"></polyline>
                        <polyline id="jmoon-path-3" class="jmoon-path" stroke-opacity="1" stroke="orange" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round" points="283.4 0 290.6 5 297.2 10 303 15 307 19 310.4 23 313.4 27 315.8 31 317.6 35 318.8 39 319.4 43 319.4 47 318.8 51 317.6 55 316 59 313.8 63 311 67 307.6 71 303.6 75 299.2 79 292.8 84 285.8 89 278 94 267.8 100 256.6 106 242.6 113 225.6 121 205.4 130 174.8 143 125.4 164 105.2 173 88.4 181 74.6 188 63.8 194 53.8 200 46.2 205 39.4 210 33.4 215 29.2 219 25.6 223 22.4 227 19.8 231 17.8 235 16.4 239 15.6 243 15.4 247 15.8 251 16.8 255 18.4 259 20.4 263 23 267 26.2 271 30 275 34.2 279 40.2 284 47 289 54.6 294 64.6 300 75.4 306 89 313 105.6 321 125.4 330 153 342 213.2 368 232.8 377 249.2 385 262.6 392 273.2 398 282.8 404 290.2 409 296.8 414 302.6 419 306.6 423 310.2 427 313.2 431 315.6 435 317.4 439 318.8 443 319.6 447 319.8 451 319.4 455 318.4 459 316.8 463 314.6 467 311.8 471 308.6 475 304.8 479 300.4 483 294.2 488 287.2 493 279.6 498 269.4 504 258.4 510 244.6 517 227.6 525 207.4 534 179.4 546 123 570 103 579 86.4 587 72.8 594 62 600 52.2 606 44.8 611 38.2 616 32.4 621 28.4 625 24.8 629 21.8 633 19.4 637 17.6 641 16.4 645 15.6 649 15.4 653 15.8 657 16.8 661 18.4 665 20.6 669 23.4 673 26.8 677 27.8 678 27.8 678"></polyline>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>

          </div>
        </div>
        <detail v-on:show-modal="showModalMsg"></detail>
      </main>
    </div>
    <menuprimary current-nav="jupiters-moons" :needNavprojects=true v-on:toggle-detail="toggleDetail"></menuprimary>
    <div class="top-tool-nav-wrap">
      <div @click="toggleDetail" v-if="isDetailVisible" class="btn-close-circle" aria-hidden="true">
        <span class="visuallyhidden">close detail content</span>
      </div>
      <share-section v-if="isDetailVisible"></share-section>
      <router-link to="overview" class="btn-close-circle" aria-hidden="true" v-else>
        <span class="visuallyhidden">go to overview page</span>
      </router-link>

    </div>
    <modal v-if="showModal" url="https://www.e-rara.ch/zut/content/zoom/227794" @close="showModal=false"></modal>
  </div>
</template>

<script>
  import jmoons from '../../data/jupiters-moons';
  import iJupitersMoons from '../info/i-jupiters-moons'
  import Modal from '../../components/modal';
  import MenuPrimary from '../../components/menu-primary';
  import Slides from '../../data/planet-slides';
  import ShareSection from '../../components/share';

  import anime from 'animejs';
  import Hammer from '../../assets/js/hammer.min';

  export default {
    name: 'jupitersmoonsComponent',
    components: {
      'detail': iJupitersMoons,
      'modal': Modal,
      'menuprimary': MenuPrimary,
      'share-section': ShareSection
    },
    data() {
      return {
        activeSlide: 0,
        bg: false,
        val: 0,
        jmoonsSlides:jmoons.data()['slides'],
        jmoons: '',
        jmoonsCurveContainer: '',
        jmoonsPathsContainer: '',
        jmoonsPathsSvg: '',
        jmoonsPathArray : [],
        jmoonsPosArray : [],
        jmoonsScaleRate : 1,
        jmoonsLastPos: 0,
        orgSvgHeight:'',
        curSvgHeight:'',
        showModal: false,
        isDetailVisible: false,
        windowWidth: window.innerWidth,
        rangeWidthLive:'',
        slideWidthLive:'',
        slides: Slides.data()['Slides'],
        workPosLive:'',
        zoomEl:'',
        mc:'',
        pinchTimmer: 0,
        isPageLoaded: false,
        instAniInterval: null,
        instStepTimer: null,
        instAniLoadTimer: null,
        pageLoadTimer: null,
        pageTop:'',
        workScaledHeight: 0,
        addAni: false
      }
    },
    created() {
      this.viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      this.isMobile = this.mobileAndTabletcheck()
    },
    methods: {
      instractionAni: function () {
        var step = 0;
        var _this = this;
        this.instAniInterval = setInterval(frame, 1000);

        function frame() {
          if (step > 1 || _this.isDetailVisible) {
            _this.clearIntervalInstAni()
            clearTimeout(_this.instStepTimer)
          }
          if (step == 0) {
            _this.$el.querySelector('.next').classList.add("scale");
            _this.instAniStart()
          }
          if (step == 1) {
            _this.$el.querySelector('.prev').classList.add("scale");
            _this.instAniEnd()
          }
          step++;
        }
      },
      instAniStart: function() {
        var _this = this;
        clearTimeout(this.instStepTimer)
        this.instStepTimer = setTimeout(function(){
          _this.$el.querySelector('.next').classList.remove("scale");
          _this.activeSlide = 8
          _this.moveMoonsWithAni();
        }, 300);
      },
      instAniEnd: function() {
        var _this = this;
        clearTimeout(_this.instStepTimer)
        this.instStepTimer = setTimeout(function(){
          _this.$el.querySelector('.prev').classList.remove("scale");
          _this.activeSlide = 0
          _this.moveMoonsWithAni();
        }, 300);
      },
      clearIntervalInstAni : function() {
        if(this.instAniInterval) {
          clearInterval(this.instAniInterval);
          this.instAniInterval = null
        }
        if(this.instAniLoadTimer != null) {
          clearTimeout(this.instAniLoadTimer);
          this.instAniLoadTimer = null
        }
      },
      stepUp: function () {
        this.activeSlide++
        if(this.activeSlide > this.jmoonsSlides.length -1) {
          this.activeSlide = this.jmoonsSlides.length -1;
        }
      },
      stepDown: function () {
        this.activeSlide--
        if(this.activeSlide < 0) {
          this.activeSlide = 0
        }
      },
      clickStepUp: function () {
        this.stepUp();
        this.moveMoonsWithAni();
      },
      clickStepDown: function () {
        this.stepDown();
        this.moveMoonsWithAni();
      },
      panStepUp: function () {
        this.stepUp();
        this.moveMoons();
      },
      panStepDown: function () {
        this.stepDown();
        this.moveMoons();
      },
      toggleDetail:function () {
        if(!this.isDetailVisible) {
          // eslint-disable-next-line no-undef
          gtag('config', this.uaId, {'page_path': this.$route.path + '-i-detail'});
        } else {
          // eslint-disable-next-line no-undef
          gtag('config', this.uaId, {'page_path': this.$route.path });

          var audio = this.$el.querySelectorAll('audio')[0];
          if(!audio.paused){
            audio.pause();
          }
        }

        this.isDetailVisible = !this.isDetailVisible
        var _scale = 1;

        if(this.isDetailVisible) {
          document.body.classList.add('detail-opened');
          _scale = 0.7;
        } else {
          document.body.classList.remove('detail-opened');
        }
        anime({
          targets: '.scale-item',
          scale: _scale,
          duration: 500,
          easing:'easeOutQuart',
          complete: function() {
            window.onresize();
          }
        });
      },
      showModalMsg : function() {
        this.showModal = true
      },
      resetWorkZoom : function() {
        var transform = "";
        this.zoomEl.style.transform = transform;
        this.zoomEl.style.webkitTransform = transform;
      },
      pageLoad : function() {
        this.isPageLoaded = true;
        let _this = this
        this.pageLoadTimer = setTimeout(function () {
          _this.$el.querySelector(".work-intro-ani-in").classList.remove('work-intro-ani-in')
        }, 1600)
      },
      initJmoons: function() {
        this.jmoons = this.$el.querySelectorAll('.jmoon');
        this.jmoonsPathsSvg = this.$el.querySelector('.jmoons-curves__path');
        this.jmoonsPathsContainer = this.$el.querySelector('.jmoons-curves-interctiv-container');
        this.jmoonsCurveContainer = this.$el.querySelector(".jmoons-curves-touch-area")
        this.createPathArray();
        this.getJmoonsScaleRate();
        this.moveMoonsWithAni();
      },
      getJmoonsScaleRate: function() {
        const curSvgWidth = this.jmoonsPathsSvg.getBoundingClientRect().width;
        const orgSvgWidth = this.jmoonsPathsSvg.viewBox.baseVal.width;
        this.orgSvgHeight = this.jmoonsPathsSvg.viewBox.baseVal.height;
        this.curSvgHeight = this.jmoonsPathsSvg.getBoundingClientRect().height;
        this.jmoonsScaleRate = curSvgWidth / orgSvgWidth;
      },
      createPathArray: function () {
        for (let i = 0; i < this.jmoons.length; i++) {
          const pathEl = this.$el.querySelector('#jmoon-path-'+i);
          const pathPointsArray = [];
          for (let j = 0; j < pathEl.getTotalLength(); j++) {
            pathPointsArray.push(pathEl.getPointAtLength(j));
          }
          this.jmoonsPathArray[i] = {
            'index': i,
            'path': pathEl,
            'pathLeng': pathEl.getTotalLength(),
            'pathPointsArray': pathPointsArray
          }
        }
      },
      getPercFromTop: function () {
        const pathHeight = this.jmoonsPathsContainer.clientHeight;
        var pathTransformY = Math.abs(parseFloat(this.jmoonsPathsContainer.style.transform.split(/[()]/)[1]));
        var percentY = pathTransformY / pathHeight;
        if(percentY >= 1) {
          percentY = 1;
        }
        if(percentY < 0) {
          percentY = 0;
        }
        return percentY;
      },
      setMoonsPosWithoutAni : function () {
        //const _this = this;
        const percentY = this.getPercFromTop();
        const goalYPos = percentY * this.orgSvgHeight;

        for (let i = 0; i < this.jmoonsPathArray.length; i++) {
          const moon = this.jmoonsPathArray[i];
          const moonPath = moon.path;
          const _pos = moonPath.getPointAtLength(moon.pathLeng * parseFloat(percentY) );

          let _posTemp = 0;
          let goalXPos = _pos.x;
          let n = 0;
          let diff = parseInt(goalYPos) - parseInt(_pos.y);

          if(percentY == 1) {
            _posTemp = moonPath.getPointAtLength(moon.pathLeng * 1);
            goalXPos = _posTemp.x;
          } else if(percentY == 0) {
            _posTemp = moonPath.getPointAtLength(0);
            goalXPos = _posTemp.x;
          } else {

            if( parseInt(goalYPos) > parseInt(_pos.y) ) {
              /* if my postion smaller than default pos */
              while (diff > 0) {
                n++;
                let _posTemp = moonPath.getPointAtLength(moon.pathLeng * (parseFloat(percentY) + (n / 1000)));
                diff =  parseInt(goalYPos) - parseInt(_posTemp.y);
                goalXPos = _posTemp.x;
              }

            } else if ( parseInt(goalYPos) < parseInt(_pos.y) ){
              /* if my postion bigger than default pos */
              while (diff < 0) {
                n++;
                let _posTemp = moonPath.getPointAtLength(moon.pathLeng * (parseFloat(percentY) - (n / 1000)));
                diff =  parseInt(goalYPos) - parseInt(_posTemp.y);
                goalXPos = _posTemp.x;
              }
            }
          }
          /* moving right is in front of jupiter, otherwise back */
          const pathNearPos = moon.path.getPointAtLength(moon.pathLeng * (parseFloat(percentY) - 0.01));
          let _zIndex = 2;

          if((_pos.x - pathNearPos.x) >= 0) {
            _zIndex = 5;
          }

          const circle = this.$el.querySelector('.jmoon-'+ i);
          const _left = goalXPos * this.jmoonsScaleRate + 'px';
          circle.style.left = _left;
          circle.style.zIndex = _zIndex;
        }
      },
      getMoonPosArray : function () {
        const _this = this;
        let slidePos = this.jmoonsSlides[_this.activeSlide].pos;
        const goalYPos = slidePos * this.orgSvgHeight;
        let currMoonsPosArray = [];
        for (let i = 0; i < this.jmoonsPathArray.length; i++) {
          const moon = this.jmoonsPathArray[i];
          const moonPath = moon.path;
          const _pos = moonPath.getPointAtLength(moon.pathLeng * slidePos);
          let goalXPos = _pos.x;
          let n = 0;

          let diff = parseInt(goalYPos) - parseInt(_pos.y);

          if( parseInt(goalYPos) > parseInt(_pos.y) ) {
            /* if my postion smaller than default pos */
            while (diff > 0) {
              n++;
              let _posTemp = moonPath.getPointAtLength(moon.pathLeng * (parseFloat(slidePos) + (n / 1000)));
              diff =  parseInt(goalYPos) - parseInt(_posTemp.y);
              goalXPos = _posTemp.x;
            }
          } else if ( parseInt(goalYPos) < parseInt(_pos.y) ){
            /* if my postion bigger than default pos */
            while (diff < 0) {
              n++;
              let _posTemp = moonPath.getPointAtLength(moon.pathLeng * (parseFloat(slidePos) - (n / 1000)));
              diff =  parseInt(goalYPos) - parseInt(_posTemp.y);
              goalXPos = _posTemp.x;
            }
          }

          /* moving right is in front of jupiter, otherwise back */
          const pathNearPos = moon.path.getPointAtLength(moon.pathLeng * (parseFloat(slidePos) - 0.01));
          let _zIndex = 2;

          if((_pos.x - pathNearPos.x) >= 0) {
            _zIndex = 5;
          }

          const circle = this.$el.querySelector('.jmoon-'+ i);
          const _left = goalXPos * this.jmoonsScaleRate + 'px';
          currMoonsPosArray[i] = { 'circle': circle, 'left': _left, 'zIndex': _zIndex};
        }
        return currMoonsPosArray;
      },
      getPathPos : function () {
        let slidePos = this.jmoonsSlides[this.activeSlide].pos;
        const goalYPos = slidePos * this.orgSvgHeight;
        const newPathPos = goalYPos * this.jmoonsScaleRate * -1 + 'px';
        return newPathPos;
      },
      moveMoonsWithAni : function () {
        if(this.isDetailVisible) {
          return
        }
        this.removeAni();
        const _this = this;
        const curMoonPosArray = this.getMoonPosArray();
        for (let i = 0; i < this.jmoonsPathArray.length; i++) {
          let el = curMoonPosArray[i];
          anime({
            targets: el.circle,
            left: el.left,
            zIndex: {
              value: el.zIndex,
              duration: 100
            },
            duration: 500,
            easing:'easeOutQuart',
          });
        }
        anime({
          targets: this.jmoonsPathsContainer,
          translateY: _this.getPathPos(),
          duration: 500,
          easing:'easeOutQuart',
        });
      },
      removeAni: function() {
        anime.remove(this.jmoons);
        anime.remove(this.jmoonsPathsContainer);
      },
      createJmoonsPosArray : function () {
        for (var i = 0; i < this.jmoonsSlides.length; i++) {
          this.jmoonsPosArray[i] = this.jmoonsSlides[i].pos;

        }
      },
      initMcPan : function () {
        const scrollInteract = this.jmoonsCurveContainer;
        var _this = this;
        var mc = new Hammer(scrollInteract);
        mc.get('pan').set({ direction: Hammer.DIRECTION_ALL});
        mc.on('panup pandown panend', (e) => {
          _this.clearIntervalInstAni()
          _this.panScroll(e);
        });
      },
      panScroll : function (e) {
        // eslint-disable-next-line no-undef
        gtag('event', 'panScroll', {
          'event_category' : 'jupiters-moons',
          'event_label' : 'jupiters-moons',
        });
        //get TranslateY
        const pathHeight = this.jmoonsPathsContainer.clientHeight;
        const pathTransformY = parseFloat(this.jmoonsPathsContainer.style.transform.split(/[()]/)[1]);
        const speed = 0.1;
        let updateY = null;

        /* moving stepDown hand shita ni*/
        if(e.type == 'pandown' ) {
          updateY = pathTransformY + parseInt(e.distance * speed);
          if(updateY > 0) {
            updateY = 0;
          }
        }
        /* moving stepUp hand ue ni*/
        if(e.type == 'panup') {
          updateY = pathTransformY + ((e.distance * speed) * -1);
          if(updateY < (pathHeight * -1 )) {
            updateY = pathHeight * -1;
          }
        }

        if(updateY != null) {
          this.jmoonsPathsContainer.style.transform = 'translateY(' + updateY  + 'px)';
          this.setMoonsPosWithoutAni();
        }

        if(e.type == 'panend') {
          const percentY = this.getPercFromTop();
          this.activeSlide = this.findNearest(percentY);
          this.moveMoonsWithAni();
        }
      },
      findNearest : function (goal) {
        const arrayPos = this.jmoonsPosArray;
        var closest = arrayPos.reduce(function(prev, curr) {
          return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
        });
        var slideIndex = arrayPos.indexOf(closest);
        return slideIndex
      },
    },
    beforeRouteLeave (to, from, next) {
      if(this.instStepTimer) {
        clearTimeout(this.instStepTimer)
      }
      if(this.pageLoadTimer) {
        clearTimeout(this.pageLoadTimer);
      }
      this.clearIntervalInstAni()
      document.body.classList.remove('detail-opened');
      localStorage.setItem('jupitersmoonsIndex', '');
      this.aniMenuPageLeave(next());
    },
    mounted() {
      this.createJmoonsPosArray();
      document.body.style.zoom = 1.0;
      this.pageTop = this.$el.querySelector('.page__top');
      this.windowWidth = window.innerWidth
      this.saveCurrentPlanetToLocalStorage();
      this.zoomEl = this.$el.querySelector(".work__scaleable");

      this.pageLoad();
      this.setWorkBgPos();
      this.initJmoons();
      this.initMcPan();

      if(localStorage.getItem('jupitersmoonsIndex')) {
        this.activeSlide = localStorage.getItem('jupitersmoonsIndex')
      } else {
        this.instAniLoadTimer = setTimeout(this.instractionAni,1500)
      }

      window.onresize = () => {
        //avoild resize on scroll -> addressbar collapse
        if(this.isMobile && this.windowWidth == window.innerWidth) {
          return false
        }
        this.windowWidth = window.innerWidth

        this.getJmoonsScaleRate();
        this.moveMoonsWithAni();
      }
    }
  };
</script>

<style scoped>

</style>
